import { usePotentialBookingFiltersContext } from '@sales-app/context/potentialBookingFilters/potentialBookingFilters'
import React, { useState } from 'react'

import { Dropdown } from '@/components'
import { FilterOptionsStyled } from '@/components/ListFilter/FilterOptionsStyled'

export const MoveInWithinDaysFilter = () => {
  const { moveInWithin, setFilters } = usePotentialBookingFiltersContext()

  const [dropdownExpanded, setDropdownExpanded] = useState(false)

  const number_of_days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]

  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const changeFilter = (val: number | null = null) => {
    setDropdownExpanded(false)
    if (val) {
      setFilters({ moveInWithin: val })
    } else {
      setFilters({ moveInWithin: null })
    }
  }

  const headerTitle = moveInWithin ? `${moveInWithin} days` : 'Move In Within Days'

  return (
    <Dropdown
      className="hidden w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle={headerTitle}
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!moveInWithin}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <div className="flex max-h-48 min-h-24 w-full overflow-scroll">
          <ul>
            <li className={`${!moveInWithin ? 'selected' : ''}`} onClick={() => changeFilter()} role={'presentation'}>
              All
            </li>
            {number_of_days.map((val, i) => (
              <li
                className={`${moveInWithin === val ? 'selected' : ''}`}
                key={i}
                onClick={() => changeFilter(val)}
                role={'presentation'}
              >
                {val} days
              </li>
            ))}
          </ul>
        </div>
      </FilterOptionsStyled>
    </Dropdown>
  )
}
